export interface ICountry {
  id: string;
  name: string;
  iso2: string;
  iso3: string;
}

export interface IAddress {
  id: string;
  address: string;
}

export interface IAddressDetails {
  id: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postalCode: string;
}

export enum SearchProvider {
  GOOGLE_PLACES = 'GooglePlaces',
  COMPANY_HOUSE = 'CompanyHouse',
  AUSTRALIAN_BUSINESS_REGISTRY = 'AustralianBusinessRegistry'
}

export enum OperationType {
  SIGNUP = 'SignUp',
  FOUNDATION = 'FoundationSignUp'
}

export interface IBaseCompany {
  id?: string; // CompanyHouse identifier
  companyName: string;
  country: string;
  postalCode?: string | null;
  state?: string | null;
  abn?: string | null; // AustraliaBusinessRegistry identifier
  acn?: string | null;
}

export interface ICompany extends IBaseCompany {
  city: string;
  addressLine1: string;
  addressLine2: string | null;
}
